export default function Footer({ isOwner, onUnlock }) {
  return (
    <footer data-testid="site-footer" className="border-t border-[#E0D8C6] px-6 sm:px-10 lg:px-16 py-16 text-center">
      <p className="text-[13px] font-medium tracking-[0.3em] uppercase text-[#3C3527]">Prime Collective</p>
      <p className="mt-4 font-serif italic text-xl text-[#6E6553]">A whole-person retreat for women</p>
      <p className="mt-6 text-[10px] tracking-[0.25em] uppercase text-[#6E6553]">
        The Power of Midlife · October 2–4, 2026 · Buckhorn Hollow Farms
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-8 text-[10px] tracking-[0.25em] uppercase">
        <a
          href="https://primecollective.life/"
          target="_blank"
          rel="noreferrer"
          data-testid="footer-venue-link"
          className="text-[#6E6553] hover:text-[#C4562F] transition-colors duration-300"
        >
          primecollective.life
        </a>
        <a
          href="https://www.instagram.com/primecollective.life"
          target="_blank"
          rel="noreferrer"
          data-testid="footer-instagram-link"
          className="text-[#6E6553] hover:text-[#C4562F] transition-colors duration-300"
        >
          @primecollective.life
        </a>
        <button
          onClick={onUnlock}
          data-testid="owner-manage-btn"
          className="text-[#6E6553]/60 hover:text-[#C4562F] transition-colors duration-300 uppercase tracking-[0.25em]"
        >
          {isOwner ? "Owner mode on" : "Manage"}
        </button>
      </div>
    </footer>
  );
}
